import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

export const SectionLayout = styled(FocusNode)`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  margin-right: 112px;
  margin-left: -0.75rem;
  &.isFocusedLeaf {
    box-shadow: 0 0 0 4px
      ${(props) => props.theme.colors.developer.focusedElem.border};
  }
`

export const Section = styled(FocusNode)`
  padding: 1.5rem;
  font-size: 1.4rem;
  line-height: 1.5em;
  flex: 1;
  position: relative;
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0.75rem;
    left: 0.75rem;
    width: calc(100% - 1.5rem);
    height: calc(100% - 1.5rem);
    background-color: ${(props) => props.theme.colors.developer.background};
    border-radius: 1rem;
  }
  &.isFocused {
    &:before {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }
`

export const SectionTitle = styled.header`
  position: relative;
  padding: 0.5rem;
  padding-bottom: 0;
  font-size: 1.8rem;
  line-height: 1.8rem;
  color: ${(props) => props.theme.colors.developer.title};
  text-transform: uppercase;
`

export const SectionContent = styled.div`
  position: relative;
  height: 100%;
  color: ${(props) => props.theme.colors.developer.text};
  padding: 0.5rem;
  p > span {
    opacity: 0.5;
  }
`

export const SettingsWrapper = styled(FocusNode)`
  width: 100%;
`

export const SettingsRowGroup = styled.div`
  padding: 2rem 0;
`

export const SettingsRow = styled(FocusNode)`
  width: 100%;
  display: flex;
`

export const SettingsRowTitle = styled.header`
  position: relative;
  font-size: 1.8rem;
  padding: 1rem 2rem;
  line-height: 1.8rem;
  color: ${(props) => props.theme.colors.developer.title};
  text-transform: uppercase;
  flex: 1;
`

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
